// src/components/ReactivateMembership.js
import React from "react";
import { useNavigate } from "react-router-dom";
import "./ReactivateMembership.scss"; // Importamos los estilos

const ReactivateMembership = () => {
  const navigate = useNavigate();

  const handleReactivate = () => {
    // Redirige al flujo de pago nuevamente para que reactiven la membresía
    navigate("/payment", { state: { selectedPlan: "Gold" } }); // Puedes usar el plan que tenían antes
  };

  return (
    <div className="reactivate-container">
      <h2>Tu membresía ha expirado o ha sido cancelada</h2>
      <p>
        Para acceder a todas las funciones, por favor reactiva tu membresía.
      </p>
      <button className="btn-accion" onClick={handleReactivate}>
        Reactivar Membresía
      </button>
    </div>
  );
};

export default ReactivateMembership;
